import { Chip, ListItemIcon, ListItemText, MenuItem } from '@mui/material'
import { Edit2, Eye, Lock } from 'react-feather'

// Imports custom
import {
    TooltipInformation,
    CustomTableData,
    LinearLoading,
    CustomDropDown
} from '../../../../common'

export const ParametrosSistemaTable = ({ useFetchInit }) => {
    
    const {
        FetchData,
        Actions
    } = useFetchInit

    const { fetchAllParametrosSistema } = FetchData
    const { dataParametrosSistema, loadingFetchAllParametrosSistema } = fetchAllParametrosSistema

    const { 
        handleClickFetchSpecificParametroSistema
    } = Actions

    const columnConfig = [
        {
            //FIELD PARA TOOLTIP
            headerName: 'Info',
            maxWidth: 80,
            cellStyle: () => ({
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }),
            cellRenderer: (params) => {
                //DESESTRUCTURACIÓN DE DATA PARA MOSTRAR EN TOOLTIP
                const { usuario_creo, fecha_creo, usuario_modifico, fecha_modifico } = params.data
                return (
                    <TooltipInformation
                        usuario_creo={usuario_creo}
                        fecha_creo={fecha_creo}
                        usuario_modifico={usuario_modifico}
                        fecha_modifico={fecha_modifico}
                    />
                )
            }
        },
        { field: "clave", headerName: "Clave", minWidth: 350, filter: true },
        { field: "valor", headerName: "Valor", minWidth: 250, filter: true },
        {
            headerName: 'Edición',
            minWidth: 180,
            cellRenderer: (params) => {
                const { editable } = params.data

                return (
                    <span>
                        {Number(editable) === 1
                            ? 'Editable'
                            : 'Solo lectura'
                        }
                    </span>
                )
            }
        },
        {
            headerName: 'Estado',
            minWidth: 130,
            cellRenderer: (params) => {
                const { estado } = params.data

                return (
                    <Chip
                        label={Number(estado) === 1 ? 'Activo' : 'Inactivo'}
                        color={Number(estado) === 1 ? 'success' : 'default'}
                        size="small"
                    />
                )
            }
        },
        {
            headerName: 'Acciones',
            minWidth: 130,
            cellRenderer: (params) => {
                const { idenvironment, editable } = params.data

                return (
                    <CustomDropDown color='inherit'>
                        <MenuItem
                            onClick={() => handleClickFetchSpecificParametroSistema(idenvironment)}
                        >
                            <ListItemIcon>
                                {(editable === 1)&&(<Edit2 color="black"/>)}
                                {(editable === 0)&&(<Eye color="black"/>)}
                                
                            </ListItemIcon>
                            <ListItemText primary="Informacion" />
                        </MenuItem>
                    </CustomDropDown>
                )
            }
        }
    ]

    return (
        <div className='content'>
            {(loadingFetchAllParametrosSistema) && (<LinearLoading/>)}
            <CustomTableData 
                rowConfig={dataParametrosSistema}
                columnConfig={columnConfig}
            />
        </div>
    )
}
